import { render, staticRenderFns } from "./InlineAlign.vue?vue&type=template&id=27628215&"
import script from "./InlineAlign.vue?vue&type=script&lang=js&"
export * from "./InlineAlign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports